import { Model } from 'json-api-models';
import { uniq } from 'lodash-es';

import { Models, Schemas } from '../models.ts';
import { splitLeadingEmoji } from '../utils/emoji.ts';

export class Pack extends Model<Schemas['packs'], Models> {
    get emoji() {
        return splitLeadingEmoji(this.name).emoji;
    }

    get title() {
        return splitLeadingEmoji(this.name).text;
    }

    acceptsContentType(contentType?: string) {
        return !contentType || (this.contentTypes?.includes(contentType) ?? false);
    }

    get curricula() {
        return uniq(
            [
                this.curriculum,
                ...(this.products?.map((product) => product?.curriculum) || []),
            ].filter((c) => !!c),
        );
    }
}
